import * as React from "react";
import {css, cx} from "emotion";
import {rgba} from "polished";

import "./left-nav-item.scss";

import {ActiveWheel}    from "@Common/react/active-wheel";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {isBlankStr}     from "@Common/utils/strings";

import {MenuInternalLink} from "../../../../common/components/internal-link";
import {getAbsLink}       from "../../../../common/get-abs-link";

export const LeftNavItem = ({active, navBlock=undefined, ...menu}) => cs(
    consumeContext("themeScheme"),
    consumeContext("editor"),
    ["hovered", (_, next) => UseState({next})],
    ({hovered, themeScheme, editor}) => (
        <div
            className={cx(
                "item-ov1 left-nav-item-4jdw", {hovered: hovered.value, active},
                css`
                    & > .toggle-ov1 {
                        color: ${themeScheme.xpresso.menuTextColor} !important;
                        &:after {
                            background: ${themeScheme.xpresso.menuTextColor};
                        }
                    }
                `
            )}
            onMouseEnter={(e) => {
                // @ts-ignore
                hovered.onChange(e.target.getBoundingClientRect());
            }}
            onMouseLeave={() => hovered.onChange(null)}
            onClick={() => hovered.onChange(null)}
        >
            {menu?.type === "internalUrl" ? (
                MenuInternalLink({
                    to: menu?.link,
                    className: cx("toggle-ov1"),
                    "xd-qa-type": "menu",
                    "xd-qa-name": menu.linkLabel,
                    navBlock,
                    children: menu.linkLabel,
                })
            ) : (
                <ActiveWheel
                    component={"a"}
                    href={menu && !isBlankStr(menu.link) && getAbsLink(menu.link) || undefined}
                    className={cx("toggle-ov1")}
                    onWheel={(e) => {
                        e.preventDefault();
                    }}
                    onClick={async (e) => {
                        e.preventDefault();
                        if (await navBlock?.block() === true) {
                            return;
                        }
                        window.location.href = menu && !isBlankStr(menu.link) && getAbsLink(menu.link) || undefined;
                    }}
                    xd-qa-type="menu"
                    xd-qa-name={menu.linkLabel}
                >
                    {menu.linkLabel}
                </ActiveWheel>
            )}

            {hovered.value && menu.rDropdown && (
                <ActiveWheel
                    className={cx("dropdown-ov1", {editor: editor?.value})}
                    style={{
                        top: hovered.value.bottom,
                        background: rgba(themeScheme.xpresso.menuBackgroundColor, 0.97),
                    }}
                    onWheel={(e) => {
                        // @ts-ignore
                        if (e.target.classList.contains("dropdown-ov1")) {
                            e.preventDefault();
                        }
                    }}
                >
                    <div className="content-ov1">
                        {menu.rDropdown(hovered.value.left)}
                    </div>
                </ActiveWheel>
            )}
        </div>
    ),
);
